import React from 'react';
import cn from 'classnames';

import classes from './loader.module.scss';
import { ILoader } from './types';

const Loader: React.FC<ILoader> = ({ className = '', itemClassName = '' }) => {
	return (
		<div className={cn(classes.loader, className)}>
			<span className={cn(classes.loaderItem, classes.loaderItem__first, itemClassName)} />
			<span className={cn(classes.loaderItem, classes.loaderItem__second, itemClassName)} />
			<span className={cn(classes.loaderItem, classes.loaderItem__third, itemClassName)} />
		</div>
	);
};

export default Loader;
